var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group',{attrs:{"prepend":_vm.prepend}},[_c('b-form-input',{staticClass:"text-right",attrs:{"value":_vm.rawValue,"disabled":_vm.disabled},on:{"input":_vm.onInput,"focus":_vm.onFocus,"blur":_vm.onBlur,"beforeinput":_vm.onBeforeInputHandler}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94e95384","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/portal-components/value-added-tax/vat-return/vat-return-table/vat-currency-input.vue
// module id = fOSD
// module chunks = 23